<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="outcomeColumn"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Define outcome column and formula
                    </b>
                    <span>
                        e.g. “revenues”, “margin”, “total production”, etc.
                    </span>
                </div>
            </div>
        </div>
        <div [ngClass]="{'loading':!dataLoaded, 'middle-part' :true, 'set-up':true}">
            <div class="current-status">
                <div class="left">
                    <div class="dot green"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
                <div class="divider"></div>
                <div class="right">
                    <div class="wrap">
                        <b *ngIf="selectedColumn" class="text-bracket">{{selectedColumn.name}}</b> selected as <b>outcome</b> column –
                        <ng-container *ngIf="!selectingOutcome">
                            <button (click)="selectingOutcome = true" [ngClass]="{' loading-small':loading, 'btn-gray':true, 'btn':true, 'btn-small':true }">click here</button> to change
                        </ng-container>
                        <ng-container *ngIf="selectingOutcome">
                            click on another numerical column (#) to change <help-link helpId="20"></help-link>
                        </ng-container>
                    </div>
                    <div class="wrap formula">
                        <div class="formula_text">
                            Edit the outcome formula as needed ⓘ <b *ngIf="selectedColumn" class="text-bracket">{{selectedColumn.name}}</b>
                            <span class="equal">=</span>
                        </div>
                        <div class="formula_input">
                            <input class="no-border" [(ngModel)]="formula" (input)="formulaChanged()" type="text">
                            <button autofocus (click)="save()" [ngClass]="{' loading-small':loading, 'btn-green':!refineFormula, 'btn-red':refineFormula, 'btn':true, 'btn-small':true }">{{ refineFormula ? 'Refine formula' : 'Done' }}</button>
                        </div>
                    </div>
                    <div class="wrap" *ngIf="selectedColumn">
                        Or <button (click)="noformula()" [ngClass]="{ 'loading-small':loading, 'btn':true, 'btn-gray':true, 'btn-small':true }">continue here</button> if you just want to focus on <b
                            class="text-bracket">{{selectedColumn.name}}</b> without breaking out the components
                            <help-link helpId="22"></help-link>
                    </div>

                </div>
            </div>
            <div class="table-data">
                <table>
                    <thead>
                    <tr>
                        <th *ngFor="let col of columns" (click)="columnClicked(col)" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected, 'green-bg':col.mentionedInFormula}">
                            <span *ngIf="col.wasSelectedBefore" class="icon-check">✓</span> {{col.name}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="small-font">
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected}">
                            <ng-container *ngIf="col.isNumerical">
                                <b class="green">#</b>,&nbsp;
                            </ng-container>
                            {{ displayRoughNum(col.uniqueValues) }}
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length">
                                <div class="gray">
                                    {{col.someVals[0]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                                <div class="gray">
                                    {{col.someVals[1]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                                <div class="gray">
                                    {{col.someVals[2]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                                <div class="gray">
                                    {{col.someVals[3]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                                <div class="gray">
                                    {{col.someVals[4]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</main>
